import { gql } from 'apollo-angular';

export const INITIATE_TERMINAL_REGISTRATION = gql`
  mutation InitiateRegistration($input: TerminalRegistrationInitiateDtoInput) {
    initiateRegistration(input: $input) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        address
        attachableDiscriminator
        bucketName
        createdAt
        createdBy
        ewuraExpireDate
        ewuraLicenseNumber
        ewuraRegDate
        lgaExpireDate
        lgaLicenseNumber
        lgaRegDate
        otherAttachmentName
        referenceNumber
        regionDistrict
        registrationType
        status
        terminalName
        updatedAt
        updatedBy
        uuid
        workflowDefinitionKey
        workflowInstanceId
        workflowStatus
      }
    }
  }
`;

export const GET_TERMINAL_REGISTRATION_PROGRESS = gql`
  query GetTerminalRegistrationProgress($terminalUuid: UUID!) {
    getTerminalRegistrationProgress(terminalUuid: $terminalUuid) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        allSectionsComplete
        applicationSubmitted
        applicationSubmittedAt
        documentCompletedAt
        ewuraLicenseVerificationComplete
        ewuraLicenseVerificationCompletedAt
        paymentComplete
        paymentCompletedAt
        requiredDocumentComplete
        terminalDetailsComplete
        terminalDetailsCompletedAt
        terminalTankComplete
        terminalTankCompletedAt
        uuid
        terminalRegistrationRequest {
          active
          address
          attachableDiscriminator
          bucketName
          ewuraExpireDate
          ewuraLicenseNumber
          ewuraRegDate
          lgaExpireDate
          lgaLicenseNumber
          lgaRegDate
          otherAttachmentName
          referenceNumber
          regionDistrict
          registrationType
          status
          terminalName
          uuid
          company {
            active
            brelaRegistrationNumber
            companyType
            id
            name
            registrationStatus
            registrationType
            taxPayerCenter
            taxPayerName
            taxPayerRegion
            taxPayerRegistrationDate
            taxpayerNumber
            tin
            tinOrTaxpayerNumber
            uuid
          }
           tanks {
                active
                capacity
                certificateIssueDate
                certificateNumber
                certificateValidFrom
                certificateValidTo
                deadStock
                issuingAuthority
                otherAttachmentName
                registrationType
                status
                tankNumber
                uuid
                 tankProducts {
                    active
                    uuid
                    product {
                        active
                        colorCode
                        id
                        isBps
                        minCapacityMt
                        productCode
                        productName
                        uuid
                    }
                    productUnitConversion {
                        active
                        conversionFactor
                        uuid
                        product {
                            active
                            colorCode
                            id
                            isBps
                            minCapacityMt
                            productCode
                            productName
                            updatedAt
                            updatedBy
                            uuid
                        }
                        unitOfMeasure {
                            active
                            code
                            name
                            uuid
                        }
                    }
                }
                attachments {
                    active
                    id
                    minioObjectName
                    otherAttachmentName
                    uuid
                    attachable {
                        attachableDiscriminator
                        bucketName
                        id
                        otherAttachmentName
                        registrationType
                        uuid
                    }
                    attachmentType {
                        active
                        fileSize
                        fileType
                        id
                        kind
                        name
                        uuid
                    }
                }
            }
          attachments {
            active
            id
            minioObjectName
            otherAttachmentName
            uuid
            attachable {
              attachableDiscriminator
              bucketName
              id
              otherAttachmentName
              registrationType
              uuid
            }
            attachmentType {
              active
              fileType
              fileSize
              id
              name
              uuid
            }
          }
        }
      }
    }
  }
`;

export const ADD_TERMINAL_DETAILS = gql`
  mutation AddTerminalDetails($input: TerminalReqInput) {
    addTerminalDetails(input: $input) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        terminalName
        uuid
       tanks {
          active
          capacity
          certificateIssueDate
          certificateNumber
          certificateValidFrom
          certificateValidTo
          deadStock
          issuingAuthority
          otherAttachmentName
          registrationType
          status
          tankNumber
          uuid
            tankProducts {
                    active
                    uuid
                    product {
                        active
                        colorCode
                        id
                        isBps
                        minCapacityMt
                        productCode
                        productName
                        uuid
                    }
                    productUnitConversion {
                        active
                        conversionFactor
                        uuid
                        product {
                            active
                            colorCode
                            id
                            isBps
                            minCapacityMt
                            productCode
                            productName
                            updatedAt
                            updatedBy
                            uuid
                        }
                        unitOfMeasure {
                            active
                            code
                            name
                            uuid
                        }
                    }
                }
         attachments {
            active
            id
            minioObjectName
            otherAttachmentName
            uuid
            attachable {
                attachableDiscriminator
                bucketName
                id
                otherAttachmentName
                registrationType
                uuid
            }
            attachmentType {
                active
                fileSize
                fileType
                id
                kind
                name
                uuid
            }
        }
    }
}
    }
  }
`;

export const FETCH_EWURA_LICENCE = gql`
  query FetchEwuraLicence($licenseNumber: String) {
    fetchEwuraLicence(licenseNumber: $licenseNumber) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        appRefNo
        approvedDate
        cellPhone
        compName
        createdAt
        createdBy
        dailyStockBal
        districtName
        email
        expDate
        expiryDate
        licenseClass
        licenseNo
        licenseType
        marketShare
        name
        regDate
        regNumber
        regionName
        sector
        status
        tin
        updatedAt
        updatedBy
        uuid
        zoneName
      }
    }
  }
`;

export const ADD_EWURA_LICENSE = gql`
  mutation AddEwuraLicense($input: RequiredLicenseReqInput) {
    addEwuraLicense(input: $input) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        address
        attachableDiscriminator
        bucketName
        createdAt
        createdBy
        ewuraExpireDate
        ewuraLicenseNumber
        ewuraRegDate
        lgaExpireDate
        lgaLicenseNumber
        lgaRegDate
        otherAttachmentName
        referenceNumber
        regionDistrict
        registrationType
        status
        terminalName
        updatedAt
        updatedBy
        uuid
        workflowDefinitionKey
        workflowInstanceId
        workflowStatus
      }
    }
  }
`;

export const FETCH_LGA_LICENCE = gql`
  query FetchLgaLicence($licenseNumber: String) {
    fetchLgaLicence(licenseNumber: $licenseNumber) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        businessName
        businessType
        businessTypeCode
        controlNumber
        council
        email
        expireDate
        id
        issueDate
        licenseFee
        licenseNumber
        mobileNumber
        mtaaVillage
        paidAmount
        previousLicenseNumber
        region
        tin
        ward
      }
    }
  }
`;

export const ADD_LGA_LICENSE = gql`
  mutation AddLgaLicense($input: RequiredLicenseReqInput) {
    addLgaLicense(input: $input) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        address
        attachableDiscriminator
        bucketName
        createdAt
        createdBy
        ewuraExpireDate
        ewuraLicenseNumber
        ewuraRegDate
        lgaExpireDate
        lgaLicenseNumber
        lgaRegDate
        otherAttachmentName
        referenceNumber
        regionDistrict
        registrationType
        status
        terminalName
        updatedAt
        updatedBy
        uuid
        workflowDefinitionKey
        workflowInstanceId
        workflowStatus
      }
    }
  }
`;

export const SUBMIT_TERMINAL_APPLICATION = gql`
  mutation SubmitTerminalApplication($input: TerminalApplicationReqInput) {
    submitTerminalApplication(input: $input) {
      code
      data {
        active
        address
        attachableDiscriminator
        bucketName
        createdAt
        createdBy
        ewuraExpireDate
        ewuraLicenseNumber
        ewuraRegDate
        lgaExpireDate
        lgaLicenseNumber
        lgaRegDate
        otherAttachmentName
        referenceNumber
        regionDistrict
        registrationType
        status
        terminalName
        updatedAt
        updatedBy
        uuid
        workflowDefinitionKey
        workflowInstanceId
        workflowStatus
      }
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const GENERATE_TERMINAL_CONTROL_NUMBER = gql`
  mutation GenerateControlNumber($billUuid: String!) {
    generateControlNumber(billUuid: $billUuid) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        amountDue
        billDate
        billNumber
        billOpt
        billStatus
        billType
        billableId
        billableType
        billedBy
        billedEntityId
        billedEntityType
        canCancel
        canRequestControlNumber
        cancelAffected
        cancelReason
        changeBy
        changeReason
        cnDelivered
        collectionCenter
        controlNumber
        controlNumberExpiredDate
        currency
        description
        exchangeRate
        gfsCode
        id
        invoiceDate
        invoiceNumber
        invoicedBy
        modeOfSettlement
        paidAmount
        remarks
        sourceRef
        spCode
        subSpCode
        taxAmount
        totalAmount
        totalAmountAfterTax
        totalEqvAmount
        uuid
      }
    }
  }
`;

export const REMOVE_TERMINAL_TANK = gql`
  mutation RemoveTerminalTank($input: RemoveTerminalTankInput!) {
    removeTerminalTank(input: $input) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        address
        attachableDiscriminator
        bucketName
        ewuraExpireDate
        ewuraLicenseNumber
        ewuraRegDate
        lgaExpireDate
        lgaLicenseNumber
        lgaRegDate
        otherAttachmentName
        referenceNumber
        regionDistrict
        registrationType
        status
        terminalName
        uuid
        workflowDefinitionKey
        workflowInstanceId
        workflowStatus
        tanks {
          active
          capacity
          deadStock
          status
          tankNumber
          uuid
          product {
            active
            productName
            uuid
          }
        }
      }
    }
  }
`;
